import { Component, Input } from '@angular/core';
import { ConfigurationManager } from './provider/ConfigurationManager';
import { Geolocation } from '@ionic-native/geolocation';

import {
  LocationService,
  MyLocation
} from '@ionic-native/google-maps';
import { NavParams } from 'ionic-angular';
/**
 * Generated class for the DnrsavingsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
declare var google;

@Component({
  selector: 'dnrsavings',
  templateUrl: 'dnrsavings.html'
})
export class DnrsavingsComponent {

  text: string;

/*   _params: any;
  _index: any;
  @Input()
  set params(params: any) {
    this._params = params;
  }

  @Input()
  set index(index: any) {
    this._index = index;
  } */
  tabIndex;
  apiKey = 'AIzaSyBvIYb1zCJpgz8EuCtXg0K4zxhH0afc3yo';


  constructor(
    private manager: ConfigurationManager,
    private geolocation: Geolocation,
    private params: NavParams) {
    console.log('Hello DnrsavingsComponent Component');
    this.text = 'Hello World dnr';
    this.initConfigurationManager();
    this.getLocation();
    this.loadGoogleMaps();
  }

  getLocation() {
 /*    if (null != LocationService) {
      LocationService.getMyLocation().then((myLocation: MyLocation) => {
        console.log('Hello DnrsavingsComponent location lat' + myLocation.latLng.lat);
        console.log('Hello DnrsavingsComponent location long' + myLocation.latLng.lng);
        this.manager.setLatitude = myLocation.latLng.lat;
        this.manager.setLongitude = myLocation.latLng.lng;
      });
    } */

    this.geolocation.getCurrentPosition().then((resp) => {
      this.manager.setLatitude = resp.coords.latitude;
      this.manager.setLongitude = resp.coords.longitude;
     }).catch((error) => {
       console.log('Error getting location', error);
       this.manager.setLatitude = 0;
       this.manager.setLongitude = 0;
     });

  }

  initConfigurationManager() {
    this.manager.setCustomerToken = (this.params.data.CustomerToken) ? this.params.data.CustomerToken : '';
    this.manager.setAuthinticated = (this.params.data.CustomerToken) ? true : false;
    this.manager.setProxyUI = (this.params.data.ProxyUI) ? this.params.data.ProxyUI : '';
    this.manager.setClubCode = (this.params.data.ClubCode) ? this.params.data.ClubCode : '';
    this.manager.setEnvironmentConfig = (this.params.data.EnvironmentName) ? this.params.data.EnvironmentName : '';
    this.manager.setZipCode = (this.params.data.ZipCode) ? this.params.data.ZipCode : '';
    this.tabIndex = this.params.data.tabIndex;
  }

  ngOnDestroy() {
    console.log('Dnrsavings Destroyed');
  }

  loadGoogleMaps() {
    // this.addConnectivityListeners();

    if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
      console.log('Google maps JavaScript needs to be loaded.');
      console.log('online, loading map');

        // Load the SDK
      window['mapInit'] = () => {
         // this.initMap(locations);
         // this.enableMap();
        };

      const script = document.createElement('script');
      script.id = 'googleMaps';

      // tslint:disable-next-line:prefer-conditional-expression
      if (this.apiKey) {
          script.src = 'http://maps.google.com/maps/api/js?key=' + this.apiKey + '&callback=mapInit';
        } else {
          script.src = 'http://maps.google.com/maps/api/js?callback=mapInit';
        }

      document.body.appendChild(script);
    } else {
      const intertn = true;
      if (intertn) {
        console.log('showing map');
        // this.initMap(locations);
        // this.enableMap();
      } else {
        // console.log("disabling map");
       //  this.disableMap();
      }

    }

  }

}
